/**
 * Created by amanjure on 3/11/16 and modified by Amy Huang on 08/01/16.
 * Works only with the new picturefill (3+) on core layout and will replace the data-srcset attribute with srcset attribute for the browser to load images
 * How it works:
 * 1 - Looks for all img tags with lazy-srcset attributes
 * 2 - on viewport, replaces all lazy-srcset with srcset and triggers the view for the browser
 * 3- de-registers the scroll and load events when
 */

class FsLazyLoad {

    constructor () {
        this.handlr = undefined;
    }

    loadImage (el) {
        let srcset = el.getAttribute('lazy-srcset');
        if (el !== 'undefined') {
            el.setAttribute('srcset', srcset);
            el.removeAttribute("lazy-srcset");
        }
    }

    /**
     * this function checks if the image is in viewport and returns true false accordingly
     * @param el element in question
     * @returns {boolean} true if in viewport, false otherwise
     */
    elementInViewport (el) {
        let rect = el.getBoundingClientRect();
        return (
            rect.top >= 0
            && rect.left >= 0
            && rect.top <= (window.innerHeight || document.documentElement.clientHeight)
        )
    }

    /**
     * This function is called on every scroll and it determines if the image is in viewport and if yes, then we load the image
     */
    processScroll () {
        let images = this.getImages();
        let len = images.length;
        for (let i = 0; i < len; i++) {
            if (this.elementInViewport(images[i])) {
                this.loadImage(images[i]);
            }

        }
        if (images.length === 0) {
            this.deinit();
        }


    }

    /**
     * Returns the images as an array set in the page
     * @param that
     * @returns {Array}
     */
    getImages () {
        let qry = document.querySelectorAll('#main img[lazy-srcset], .body-content img[lazy-srcset]');
        let images = new Array();
        for (let i = 0, l = qry.length; i < l; i++) {
            images.push(qry[i]);
        }
        return images;
    }

    /**q
     * Init function which triggers the load of lazyLoad Script on Document Load.
     */
    init () {
        this.handlr = () => this.processScroll() ;
        window.addEventListener('scroll', this.handlr, false);
        window.addEventListener('load', this.handlr, false);
    }

    /**
     * deInit function which removes all the listeners from the page
     */
    deinit () {
        window.removeEventListener('scroll', this.handlr, false);
        window.removeEventListener('load', this.handlr, false);
    }

}

export default FsLazyLoad;



// WEBPACK FOOTER //
// ./assets/components/fsLazyLoad/FsLazyLoad.js